import { render } from "./ClientSpaceAccount.vue?vue&type=template&id=851b5d2c&scoped=true"
import script from "./ClientSpaceAccount.vue?vue&type=script&lang=js"
export * from "./ClientSpaceAccount.vue?vue&type=script&lang=js"

import "./custom-clientSpace.scss?vue&type=style&index=0&id=851b5d2c&lang=scss&scoped=true"
import "./custom-clientSpaceAccount.scss?vue&type=style&index=1&id=851b5d2c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851b5d2c"]])

export default __exports__